import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AddRecipientModal } from '../../message-modals/add-recipient/add-recipient';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataTableComponent } from '../../ui/data-table/data-table.component';

@Component({
  selector: 'legacy-add-tags-modal',
  standalone: true,
  imports: [CommonModule, AddRecipientModal, FormsModule, ReactiveFormsModule, DataTableComponent],
  templateUrl: './add-tags-component.html',
  styleUrls: ['./add-tags-modal.css'],
})
export class AddTagsModal {
  @Input() data: any[] = []; // Pass data from parent
  @Input() add_recipient: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() selectedTagsChange = new EventEmitter<any[]>();
  @Input() selectedTags: any[] = [];

  // Form Control for search input
  searchControl = new FormControl('');

  // Track selected tags and search query
  tag_list: any[] = [];
  allSelectedTags = false;
  searchParam: string = '';

  constructor(
    private router: Router,
    private contactsService: ContactsService
  ) {}

  // Close modal
  closeModal(): void {
    this.close.emit();
  }

  // Fetch tags from service
  fetchTags(): void {
    this.contactsService.fetchTags({
      'name.contains': this.searchParam,
    });

    this.contactsService.getTags.subscribe({
      next: (data) => {
        this.tag_list = data.map((tag) => ({
          ...tag,
          selected: this.selectedTags.some(
            (selected) => selected.uuid === tag.uuid
          ),
        }));
      },
      error: (err) => {
      },
    });
  }

  // Update search query and fetch new tags
  getSearchParam(searchTerm: string): void {
    this.searchParam = searchTerm;
    this.fetchTags();
  }

  // Toggle selection of all tags
  toggleAllTags(event: any): void {
    this.allSelectedTags = event.target.checked;
    this.tag_list.forEach((tag) => {
      tag.selected = this.allSelectedTags;
    });
    this.updateSelectedTags();
  }

  // Update selected tags based on checkbox state
  checkSelectionTag(): void {
    this.updateSelectedTags();
  }

  // Update selectedTags array and emit to parent component
  updateSelectedTags(): void {
    this.selectedTags = this.tag_list.filter((tag) => tag.selected);
    this.selectedTagsChange.emit([...this.selectedTags]); // Emit new reference
  }

  // Persist selected tags to localStorage
  persistSelectedTags(): void {
    localStorage.setItem('selectedTags', JSON.stringify(this.selectedTags));
  }

  // Load previously selected tags from localStorage
  loadSelectedTags(): void {
    const savedTags = localStorage.getItem('selectedTags');
    if (savedTags) {
      this.selectedTags = JSON.parse(savedTags);

      this.tag_list = this.tag_list.map((tag) => ({
        ...tag,
        selected: this.selectedTags.some(
          (selectedTag) => selectedTag.uuid === tag.uuid
        ),
      }));
    }
  }

  // Filter data based on search term
  filterData(searchTerm: string, param = 'message_subject'): any[] {
    if (!searchTerm) {
      return this.data;
    }

    return this.data.filter((item) =>
      item[param].toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Lifecycle method: onInit
  ngOnInit(): void {
    this.fetchTags();

    // Reactive search input listener
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: any) => {
        this.searchParam = value;
        this.fetchTags();
      });

    // Load previously selected tags
    this.loadSelectedTags();
  }

  // // Lifecycle method: onDestroy
  // ngOnDestroy(): void {
  //   this.persistSelectedTags(); // Persist selected tags on component destroy
  // }

  // Lifecycle method: onChanges
  ngOnChanges(): void {
    // Update selected state of tags when selectedTags input changes
    this.tag_list.forEach((tag) => {
      tag.selected = this.selectedTags.some(
        (selectedTag) => selectedTag.uuid === tag.uuid
      );
    });
  }
}
